import { enableProdMode, NgModuleRef } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { Environment } from './model';

enableProdMode();

// Can use config here from config.js (same way as jQuery)
declare var config: any;

export const environment: Environment = {
  production: true,

  // trying to export config from .js file which is NOT compiled into main.xxxx.ts
  // we need this .js file with the static filename to substitute strings in it with pacify as well as the container launch.sh
  config: config
};
